const MINUTES_PER_DAY = 24 * 60;

export const TIME_FORMAT_REGEX = /^([0-1]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/;
export const TIME_PLACEHOLDER = 'HH:mm';

export default MINUTES_PER_DAY;
